import React from 'react';
import { I18n } from '../types';

export interface EmbeddedContainerProps {
  i18n: I18n;
  className: string;
  children?: any;
  customFilter?: (item: any, search: string) => boolean;
  childrenProps?: any;
}

export const EmbeddedContainer: React.FC<EmbeddedContainerProps> = (props) => (
  <div className={props.className}>
    {React.Children.map(props.children, (child) => React.cloneElement(child, {
      i18n: props.i18n,
      customFilter: props.customFilter,
      childrenProps: props.childrenProps,
      ...props,
    }))}
  </div>
);
